export default function HomeFutureMineralsSilderLoading() {
  return (
    <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5`}>
      {/* Loading animation for small screens */}
      <div className={`border-muted-300 col-span-1 flex h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 bg-white`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div>
      <div className={`border-muted-300 hidden h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 sm:col-span-1 sm:flex`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/industrial-color/industrial-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/industrial-color/industrial-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div>
      <div className={`border-muted-300 hidden h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 sm:col-span-1 sm:flex`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/security-food/security-food-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/security-food/security-food-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`border-muted-300 hidden h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 md:col-span-1 md:flex`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div>

      <div className={`border-muted-300 hidden h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 lg:col-span-1 lg:flex`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/industrial-color/industrial-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/industrial-color/industrial-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div>

      <div className={`border-muted-300 hidden h-[218px] w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 xl:col-span-1 xl:flex`}>
        <div className="relative h-full w-full">
          <img
            src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
            alt="background icon"
            className="absolute -bottom-10 -right-10 w-36 opacity-25"
          />
          <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
            <div className="absolute right-2 top-2">
              <img
                src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                alt="icon"
                className="w-8"
              />
            </div>
            <div className="bg-muted-300 h-[100px] w-[100px]" />
            <div className="flex flex-col items-center">
              <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
              <p className="bg-muted-300 h-[16px] w-6"></p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}
